// This is just an example,
// so you can safely delete all default props below

export default {
    previous_step: 'Back',
    pay_with_vipps_or_card: "Pay with Vipps / Bank card",
    reserve_with_kolumbus_product: "Reserve with a Kolumbus product",
    reserve_free_ferry: "Reserve free ferry ticket",
    reserve_auto_pass: "Reserve AutoPASS / FerryPay ticket",
    reserve_with_kolumbus_travel_money: 'Kolumbus Card (Travelmoney / Company account)',
    reserve_with_kolumbus_mobile_ticket: 'The ticket app Kolumbus Billett (30-day period ticket)',
    reserve_with_kolumbus_card: 'Kolumbus Card (30-day period ticket)',
    not_available_due_to_vehicle: 'Not accessible on this route with vehicle.',
    vehicles: 'Vehicles',
    vehicle: 'Vehicle',
    make_and_model: 'Make and model',
    registration_number: 'Registration number',
    contact_information: 'Contact Information',
    given_name: 'First Name',
    family_name: 'Last Name',
    address_line_1: 'Address',
    postal_code: 'Postal Code',
    locality: 'City',
    country_code: 'Country',
    phone_number: 'Mobile Number: <i>is used to send you an SMS if there are changes to your journey. It is important that you provide a mobile phone number that you have available during your trip.</i>',
    email: 'Email: <i>is used to receive the travel document and notify you of changes to your trip, and you need it if you want to cancel your trip. It is important that you provide an email address that you have available during your trip.</i>',
    email_repeat: 'Repeat Email: <i>double check that you use the right email address.</i>',
    pay_with_card: 'Visa / Master Card',
    read_term: 'I have read and accepted',
    required_field: 'Required Field',
    term_purchase: 'Terms for ticket shopping',
    term_reservation: "Terms for reservation",
    term_free_ferry: "Terms for free ferry",
    term_auto_pass: "Terms for AutoPASS / FerryPay",
    checkout_desc: 'I also checked that my email address is typed correctly, and that I have ordered correctly travel stretch, number of travelers, ticket category, date and departure time.<br />When paying, remember to use bank cards that have not expired, the same applies to bank cards associated with the Vipps account when using Vipps.',
    error_vehicle_info: 'Vehicle info must be supplied',
    error_vehicle_model: 'Vehicle make and model type must be supplied (minimum 4 characters/numbers)',
    error_vehicle_registration_number: 'Vehicle registration number must be supplied',
    error_given_name: 'First name must be supplied',
    error_family_name: 'Last name must be supplied',
    error_address_line_1: 'Address must be supplied',
    error_postal_code: 'Postal code must be supplied',
    error_locality: 'City must be supplied',
    error_country_code: 'Country must be supplied',
    error_phone_number: 'Mobile number is not valid',
    error_email: 'Email is not valid',
    error_email_repeat: 'Email repeated must be the same with email',
    error_agree_term: 'You have not agreed terms for shopping ticket',
    error_sub_selected_payment_method: 'One kolumbus product must be selected.'
}
